// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcm_a bhf_b bhf_uy bhf_rt bhf_ru bhf_vs","PanelFooter--link":"bcm_b"};